<svg width="0" height="0" class="cg3-icon-sprite">
    <symbol id="wk-icon-user2" viewBox="0 0 24 24" style="display: block">
        <path
            d="M17,13.2c1.4-1.3,2.2-3.1,2.2-5.2c0-4-3.2-7.2-7.2-7.2S4.8,4,4.8,8c0,2,0.8,3.9,2.2,5.2c-3.7,1.8-6.2,5.6-6.2,10h22.4
	            C23.2,18.8,20.7,15,17,13.2z M6.4,8c0-3.1,2.5-5.6,5.6-5.6c3.1,0,5.6,2.5,5.6,5.6s-2.5,5.6-5.6,5.6C8.9,13.6,6.4,11.1,6.4,8z
	            M8.5,14.3c1,0.6,2.2,0.9,3.5,0.9s2.5-0.3,3.5-0.9c3.1,1.2,5.4,4,6,7.3H2.5C3.1,18.3,5.4,15.5,8.5,14.3z"
        />
    </symbol>
</svg>
